import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  mobileFirst?: boolean;
}

export function PageContainer({
  children,
  className,
  maxWidth = 'full',
  padding = 'md',
  mobileFirst = true,
}: PageContainerProps) {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    full: 'max-w-full',
  };

  // Mobile-first responsive padding
  const paddingClasses = {
    none: '',
    sm: mobileFirst ? 'p-3 sm:p-4' : 'p-4',
    md: mobileFirst ? 'p-4 sm:p-6 lg:p-8' : 'p-6',
    lg: mobileFirst ? 'p-4 sm:p-6 lg:p-8 xl:p-10' : 'p-8',
  };

  return (
    <div
      className={cn(
        'mx-auto w-full',
        // Mobile-first responsive container
        mobileFirst && 'px-4 sm:px-6 lg:px-8',
        maxWidthClasses[maxWidth],
        paddingClasses[padding],
        className
      )}
    >
      {children}
    </div>
  );
}
